import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpError } from '../../typings';

@Injectable()
export class NavigationService {
  constructor(private router: Router, private authService: AuthService) {}

  handleError(err?: HttpError) {
    return this.router.navigate(['/error'], {
      queryParams: { code: err && err.code },
      skipLocationChange: true
    });
  }

  handleNotFound() {
    return this.router.navigate(['/404'], { skipLocationChange: true });
  }

  handleLogin(replace = false, params: any = {}) {
    return this.router.navigate(['/login'], { queryParams: params, replaceUrl: replace });
  }

  goHome(replace = false) {
    if (this.authService.hasAuthentication()) {
      return this.router.navigate(['/home'], { replaceUrl: replace });
    } else {
      return this.handleLogin(replace);
    }
  }
}
